import { BaseIdRequiredRequest } from "../../../../base/request/BaseIdRequiredRequest";
import { ClienteFincaBaseResponse } from "../../../terceros/response/ClienteFincaBaseResponse";

/** Request de configuración de árboles a monitorear de una finca (`POST
 *  /configuracion/fincas-arboles/save`). `id` = id de la finca (siempre
 *  presente: se configura una finca existente). Se crea con
 *  `fx_createFincaArbolesRequest()` precargando el valor actual de la finca. */
export type FincaArbolesRequest = BaseIdRequiredRequest & {
  /** Cantidad de árboles que el monitor revisa por sesión en cada lote.
   *  Requerido por el server. */
  arbolesMonitorear: number;
};

/** Crea el request precargado con el valor actual de la finca. */
export const fx_createFincaArbolesRequest = (
  finca: ClienteFincaBaseResponse,
): FincaArbolesRequest => {
  return {
    id: finca.id,
    arbolesMonitorear: finca.arbolesMonitorear,
  };
};
